<mat-card class="dialog-card">
  <mat-card-header class="custom-card-header">
    <mat-card-title class="custom-card-title">{{ data.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="dialog-content">
    @if (isJson) {
      <div [class.json-bg]="isJson">
        <pre class="code-block">{{ jsonData }}</pre>
      </div>
    } @else {
      <p class="dialog-message" [innerHTML]="data.message"></p>
    }
  </mat-card-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-primary (click)="onClose()">
      Close
    </button>
  </mat-dialog-actions>
</mat-card>
